import api from "../helpers/util";

export const fetchCompany = async () => {
  try {
    const response = await api.get("/company");
    return response?.data?.result ?? "No details found.";
  } catch (error) {
    throw new Error("Error fetching company details:", error);
  }
};
export const fetchCompanies = async () => {
  try {
    const response = await api.get("/company/all");
    return response?.data?.result ?? "No details found.";
  } catch (error) {
    throw new Error("Error fetching companies:", error);
  }
};
export const editCompany = async (updatedData) => {
  try {
    const response = await api.put(`/company`, updatedData);
    return response?.data?.result ?? "Company details updated successfully.";
  } catch (error) {
    throw new Error("Error editing company details:", error);
  }
};
